"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var FooterCell_1 = __importDefault(require("atomicComponents/molecules/Table/FooterCell"));
var StickyRow_1 = __importDefault(require("atomicComponents/molecules/Table/TableRows/StickyRow"));
var Money_1 = __importDefault(require("components/Money"));
var TeamsTableFooter = function (_a) {
    var isHidden = _a.isHidden, totalTeams = _a.totalTeams, totalSpend = _a.totalSpend, totalHeadcount = _a.totalHeadcount;
    return ((0, jsx_runtime_1.jsxs)(StickyRow_1.default, __assign({ bottom: 0, pl: 2, pr: 7.5, width: "100%" }, { children: [(0, jsx_runtime_1.jsxs)(FooterCell_1.default, __assign({ pl: 2, width: 200, flex: "none" }, { children: [totalTeams, " teams"] })), (0, jsx_runtime_1.jsx)(FooterCell_1.default, __assign({ width: 125, flex: "none", pr: 0.75, textAlign: "right", hidden: isHidden }, { children: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: totalSpend, isRounded: true }) })), (0, jsx_runtime_1.jsx)(FooterCell_1.default, { hidden: isHidden }), (0, jsx_runtime_1.jsx)(FooterCell_1.default, __assign({ textAlign: "right", hidden: isHidden }, { children: totalHeadcount }))] })));
};
exports.default = TeamsTableFooter;
